import { state } from '../lib/state.js';
import { els } from '../app/dom.js';
import { showWorkspace } from '../app/navigation.js';
import { loadSavedRoute } from './route-actions.js';

let routesCarrierFilter = '';

export function setRoutesCarrierFilter(value) {
  routesCarrierFilter = String(value || '').toUpperCase();
}

export function renderRoutes(){
  els.routesList.textContent='';
  const groups=new Map();
  for(const record of state.routes||[]){
    const line=String(record.route_number||record.name||'').trim();
    const carrier=String(record.carrier||'').trim().toUpperCase();
    const key=line&&carrier?`${carrier}::${line}`:`route::${record.id}`;
    if(!groups.has(key))groups.set(key,[]);
    groups.get(key).push(record);
  }

  const sorted=[...groups.values()]
    .filter(records=>!routesCarrierFilter||records.some(record=>String(record.carrier||'').trim().toUpperCase()===routesCarrierFilter))
    .sort((a,b)=>{
  const lineA=String((a[0]?.route_number||a[0]?.name)||'').trim();
  const lineB=String((b[0]?.route_number||b[0]?.name)||'').trim();

  const aStartsWithNumber=/^\d/.test(lineA);
  const bStartsWithNumber=/^\d/.test(lineB);

  // Najpierw wszystkie linie zaczynające się cyfrą.
  if(aStartsWithNumber!==bStartsWithNumber){
    return aStartsWithNumber?-1:1;
  }

  // Następnie sortowanie naturalne:
  // 1, 2, 10 oraz M1, M2, M10, N1, N2, N10.
  return lineA.localeCompare(lineB,'pl',{
    numeric:true,
    sensitivity:'base',
  });
});
  if(!sorted.length){
    els.routesList.innerHTML='<div class="routes-empty">Brak linii</div>';
    return;
  }

  for(const records of sorted){
    records.sort((a,b)=>String(b.updated_at||'').localeCompare(String(a.updated_at||'')));
    const preferred=records.find(record=>record.direction_type==='outbound')||records[0];
    const button=document.createElement('button');
    const active=records.some(record=>state.currentRoute.id===record.id);
    const current=isRouteGroupVisuallyCurrent(records);
    button.className=`route-list-item ${current?'is-current':'needs-update'}${active?' active':''}`;
    button.type='button';
    button.textContent=String(preferred.route_number||preferred.name||'Linia');
    const updatedAt=records.map(record=>record.updated_at).filter(Boolean).sort().at(-1)||'';
    button.title=`${String(preferred.carrier||'').toUpperCase()}${updatedAt?` · aktualizacja ${formatRouteListDate(updatedAt)}`:''}`;
    button.addEventListener('click',()=>{ showWorkspace('route'); loadSavedRoute(preferred); });
    els.routesList.appendChild(button);
  }
}

function isRouteGroupVisuallyCurrent(records=[]){
  const timestamps=records.map(record=>Date.parse(record?.updated_at||'')).filter(Number.isFinite);
  if(!timestamps.length)return false;
  const latest=Math.max(...timestamps);
  return Date.now()-latest<=35*24*60*60*1000;
}

function formatRouteListDate(value){
  const date=new Date(value);
  if(Number.isNaN(date.getTime()))return '';
  return new Intl.DateTimeFormat('pl-PL',{day:'2-digit',month:'2-digit',year:'numeric'}).format(date);
}

